// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2663":"6e88a563","3391":"5181fe64","7007":"57ed8d91","7907":"935459cc","8148":"89927715"}[chunkId] + ".chunk.css";
};